import { render, staticRenderFns } from "./LKI03.vue?vue&type=template&id=7d8c9872&scoped=true"
import script from "./LKI03.vue?vue&type=script&lang=js"
export * from "./LKI03.vue?vue&type=script&lang=js"
import style0 from "./LKI03.vue?vue&type=style&index=0&id=7d8c9872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c9872",
  null
  
)

export default component.exports